import React from "react";

import { translation } from "@/i18n";
import { nsAuth } from "@/i18n/locales/auth";

import styles from "./index.module.css";

const useTranslation = translation.use(nsAuth);

export const AppLoginWaiting: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.loadingApp}>
      {t.auth.loginWaiting.message()}
      <div className={styles.bar}></div>
    </div>
  );
};
